import axios from '_u/axios'

// 客户报备列表
export const customerReportList = (body) => {
    return axios.post('customer/report/list', body)
}

// 客户报备明细
export const customerReportView = (id) => {
    return axios.post('customer/report/view', { id })
}

// 修改客户报备
export const customerReportUpdate = (body) => {
    return axios.post('customer/report/update', body)
}

// 客户报备、到访、成交、结佣确认
export const customerReportConfirm = (body) => {
    return axios.post('customer/report/confirm', body)
}